import { ReactHookFormFieldErrors } from '@hero/ui-kit/types';

const scrollToFormError = (errors: ReactHookFormFieldErrors) => {
    const firstProp = Object.keys(errors)[0];

    setTimeout(() => {
        const el = document.querySelector(`#${firstProp}`);
        el && el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
};

export default scrollToFormError;
